import { fromJS } from 'immutable';

import normaliseResponse from 'utils/normaliseResponse';
import groupByEntityId from 'utils/groupByEntityId';

import * as constants from 'actions/credits/constants';
import * as orderConstants from 'actions/orders/constants';
import initialState from './initialState';

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_CREDITS_SUCCESS: {
      const { credits, projectId } = action;

      const prevAllIds = state.get('allIds');

      const normalisedResponse = normaliseResponse(credits);
      const { byId } = normalisedResponse;
      const allIdsByProject = normalisedResponse.allIds;
      const allIds = prevAllIds.concat(
        allIdsByProject.filter((id) => prevAllIds.indexOf(id) < 0)
      );

      const allIdsByInstance = groupByEntityId(credits, 'instance_id');

      return state
        .mergeDeep(fromJS({ byId }))
        .set('allIds', fromJS(allIds))
        .setIn(['byProjectId', `${projectId}`], fromJS(allIdsByProject))
        .mergeIn(['byInstanceId'], fromJS(allIdsByInstance));
    }

    case constants.ACTIVATE_CREDIT_SUCCESS: {
      const { creditId, instanceId } = action;

      const stringifiedCreditId = `${creditId}`;
      const stringifiedInstanceId = `${instanceId}`;

      const creditExists = state.getIn(['byId', stringifiedCreditId]);

      if (!creditExists) {
        // It only updates existing credits, doesn't create new ones
        return state;
      }

      // It doesn't change anything in byProjectId
      return state
        .updateIn(
          ['byId', stringifiedCreditId],
          (prevCredit) => prevCredit && prevCredit.merge(fromJS(action.credit))
        )
        .updateIn(['byInstanceId', stringifiedInstanceId], fromJS([]), (prop) =>
          prop.merge([`${action.creditId}`])
        );
    }

    case constants.SCHEDULE_CREDIT_SUCCESS: {
      const { credit, creditId, instanceId } = action;
      const isScheduled = credit.instance_id;

      const stringifiedCreditId = `${creditId}`;
      const stringifiedInstanceId = `${instanceId}`;

      const creditExists = state.getIn(['byId', stringifiedCreditId]);

      if (!creditExists) {
        // It only updates existing credits, doesn't create new ones
        return state;
      }

      // It doesn't change anything in byProjectId
      return state
        .updateIn(
          ['byId', stringifiedCreditId],
          (prevCredit) => prevCredit && prevCredit.merge(fromJS(credit))
        )
        .updateIn(
          ['byInstanceId', stringifiedInstanceId],
          (prevInstanceCredits) => {
            // We add the instanceId key if not there and we are scheduling a
            // credit on that instance
            if (!prevInstanceCredits && isScheduled) {
              return fromJS([stringifiedCreditId]);
            }

            // If we are scheduling, we push the new credit ID to the instance,
            // otherwise we remove it
            return isScheduled
              ? prevInstanceCredits.push(stringifiedCreditId)
              : prevInstanceCredits.filter((id) => id !== stringifiedCreditId);
          }
        );
    }

    case orderConstants.PURCHASE_ORDER_SUCCESS: {
      const { credits, projectId } = action;

      const normalisedResponse = normaliseResponse(credits);
      const { allIds, byId } = normalisedResponse;

      return state
        .mergeDeep(fromJS({ byId }))
        .mergeIn(['allIds'], fromJS(allIds))
        .mergeDeepIn(['byProjectId'], fromJS({ [projectId]: allIds }));
    }

    default:
      return state;
  }
};
